import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Chip,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { REPORT_TYPES, CLIENTS, DATE_RANGES, generateMockReportData } from "../../../../data";
import { generateReportPDF } from "../utils/generateReportPDF";

export default function ReportPreview({ reportType, filters }) {
  const reportInfo = REPORT_TYPES.find((r) => r.id === reportType);
  const clientInfo = filters.clientId
    ? CLIENTS.find((c) => c.id === filters.clientId)
    : null;
  const dateRangeInfo = DATE_RANGES.find((d) => d.id === filters.dateRange);

  const reportData = generateMockReportData(reportType, filters.clientId, filters.dateRange);

  const handleDownload = () => {
    generateReportPDF({
      reportType,
      reportInfo,
      clientInfo,
      dateRangeInfo,
      filters,
      reportData,
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {reportInfo?.title} Preview
          </Typography>
          <Typography sx={{ color: "var(--peb-muted)", fontSize: "0.9rem" }}>
            {clientInfo ? clientInfo.name : "All Clients"} • {dateRangeInfo?.label}
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={handleDownload}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          Download PDF
        </Button>
      </Box>

      {/* Summary Cards */}
      <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
        {Object.entries(reportData.summary).map(([key, value]) => (
          <Paper
            key={key}
            sx={{
              p: 2,
              minWidth: 140,
              background: "var(--peb-ivory)",
              border: "1px solid var(--peb-stone)",
            }}
          >
            <Typography sx={{ fontSize: "0.75rem", color: "var(--peb-muted)", textTransform: "uppercase" }}>
              {key.replace(/([A-Z])/g, " $1").trim()}
            </Typography>
            <Typography sx={{ fontSize: "1.4rem", fontWeight: 700, color: "var(--peb-ocean)" }}>
              {typeof value === "number" && value > 100
                ? `₹${value.toLocaleString()}`
                : typeof value === "number" && key.includes("growth")
                ? `${value > 0 ? "+" : ""}${value}%`
                : value}
            </Typography>
          </Paper>
        ))}
      </Box>

      {/* Data Table */}
      <Paper sx={{ overflow: "hidden", border: "1px solid var(--peb-stone)" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ background: "rgba(47, 87, 143, 0.08)" }}>
              {reportData.columns.map((col) => (
                <TableCell key={col} sx={{ fontWeight: 700 }}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData.rows.map((row, idx) => (
              <TableRow key={idx} sx={{ "&:hover": { background: "rgba(0,0,0,0.02)" } }}>
                {Object.values(row).map((val, i) => (
                  <TableCell key={i}>
                    {typeof val === "number" && val > 100
                      ? `₹${val.toLocaleString()}`
                      : val}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
